import { Injectable } from '@angular/core';
import { IPayment } from '../interfaces/ipayment';

@Injectable({
  providedIn: 'root'
})
export class StripeService implements IPayment {

  constructor() { }
  async verify(companyId: number, bookingId: number, purchaseId: number, paymentRef: any) {
    throw new Error('Method not implemented.');
  }
  async invoke(companyId: number, bookingId: number, purchaseId: number, clientId: number, description: any, fundCode: any, reference: any, price: any, vatOptOut: any) {
    throw new Error('Method not implemented.');
  }
  url: string;
  path: string;
  paymentType: string;
  test() {
    console.log(`STRIPE`);
  }

  
}
